import React from 'react';
import { string } from 'prop-types';

import classnames from 'classnames';

import { BuildIcon } from '../utils';

const namespace = 'ui-search-icon ui-search-icon--color-golden';
const ICON_ID = 'color_2450289';

const gradientId = `paint0_linear_${ICON_ID}`;

const IconColorGolden = (props) => (
  <BuildIcon
    {...props}
    className={classnames(namespace, props.className)}
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    iconId={ICON_ID}
  >
    <path
      d="M24.8533 12.5C24.8533 19.1274 19.4807 24.5 12.8533 24.5C6.22592 24.5 0.853333 19.1274 0.853333 12.5C0.853333 5.87258 6.22592 0.5 12.8533 0.5C19.4807 0.5 24.8533 5.87258 24.8533 12.5Z"
      fill="#E5BB00"
      style={{ mixBlendMode: 'hard-light' }}
    />
    <path
      d="M24.8533 12.5C24.8533 19.1274 19.4807 24.5 12.8533 24.5C6.22592 24.5 0.853333 19.1274 0.853333 12.5C0.853333 5.87258 6.22592 0.5 12.8533 0.5C19.4807 0.5 24.8533 5.87258 24.8533 12.5Z"
      fill={`url(#${gradientId})`}
      style={{ mixBlendMode: 'overlay' }}
    />
    <defs>
      <linearGradient id={gradientId} x1="-3.26097" y1="0.5" x2="22.9145" y2="26.6754" gradientUnits="userSpaceOnUse">
        <stop />
        <stop offset="0.275556" stopColor="#676666" />
        <stop offset="0.548313" stopColor="#D8D5D5" />
        <stop offset="0.80124" stopColor="#676666" />
        <stop offset="1" />
      </linearGradient>
    </defs>
  </BuildIcon>
);

IconColorGolden.propTypes = {
  className: string,
};

export default IconColorGolden;
